export const FONT_MANIFEST_PATH = "src/theme/font-manifest.json"
export const ASTRO_CONFIG_PATH = "astro.config.mjs"
export const LAYOUT_PATH = "src/layouts/Layout.astro"
export const GLOBAL_CSS_PATH = "src/styles/global.css"

export const REQUIRED_BODY_CSS_VARIABLE = "--font-provider-body"
export const REQUIRED_HEADING_CSS_VARIABLE = "--font-provider-heading"
